/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaMenu } from '../../models/criteria-menu';
import { Menu } from '../../models/menu';

export interface ApiMasterMenuGetByCriteriaPost$Params {
      body?: CriteriaMenu
}

export function apiMasterMenuGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterMenuGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Menu>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterMenuGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Menu>>;
    })
  );
}

apiMasterMenuGetByCriteriaPost.PATH = '/api/Master/Menu/GetByCriteria';
